import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    Body1,
    Button,
    Flex,
    Heading2,
    IconButton,
    IconControlledSubstance,
    Stack,
} from '@myphx-engineering/phx-design-system';

import type {
    ControlledSubstanceCode,
    PrescriberInfoFragment,
} from '../../../../graphql/generated/graphql';
import { useFlags } from '../../../../hooks/use-flags';
import { getAbsoluteRoute } from '../../../../util';
import { Prescriber } from '../../../prescriber/Prescriber';

type AltsPrescriberSectionProps = {
    prescriber: PrescriberInfoFragment;
    controlledSubstanceCode?: ControlledSubstanceCode | null;
};

export const AltsPrescriberSection = ({
    prescriber,
    controlledSubstanceCode,
}: AltsPrescriberSectionProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { helpCenterMedicationEnabled } = useFlags();

    return (
        <Stack gap="sm">
            {controlledSubstanceCode ? (
                <Stack gap="xxs">
                    <Flex gap="xxs">
                        <IconButton
                            withStyles={false}
                            Icon={IconControlledSubstance}
                            onClick={
                                helpCenterMedicationEnabled
                                    ? () =>
                                          navigate(
                                              getAbsoluteRoute(
                                                  'helpCenter.medications'
                                              )
                                          )
                                    : undefined
                            }
                        />
                        <Body1>
                            {t('controlledSubstance.modal.controlledSubstance')}
                        </Body1>
                    </Flex>
                </Stack>
            ) : null}
            <Heading2>{t('alternatives.newPrescription.title')}</Heading2>
            <Body1>{t('alternatives.newPrescription.description')}</Body1>
            <Prescriber prescriber={prescriber} />
            <Button
                onClick={() =>
                    (location.href = `tel:${prescriber.phoneNumber}`)
                }
            >
                {t('alternatives.newPrescription.callPrescriber')}
            </Button>
        </Stack>
    );
};
